import { ChevronUp, ChevronDown, ArrowLeft, ArrowRight, Check, MoveRight, Menu, X, ClockIcon,Briefcase, Mail, MapPin } from "lucide-react";
import { MdVpnKey } from "react-icons/md";
import { FaPython, FaJava, FaFigma, FaHtml5, FaNodeJs, FaReact } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { RiTailwindCssFill } from "react-icons/ri";
import { DiRuby } from "react-icons/di";
import { SiBlender, SiTypescript } from "react-icons/si";

const TechIcon = ({ name, className = "" }) => {
  const icons = {
    "chevron-up": <ChevronUp className={className} />,
    "chevron-down": <ChevronDown className={className} />,
    "arrow-left": <ArrowLeft className={className} />,
    "arrow-right": <ArrowRight className={className} />,
    "move-right": <MoveRight className={className} />,
    check: <Check className={className} />,
    menu: <Menu className={className} />,
    x: <X className={className} />,
    "md-vpn-key": <MdVpnKey className={className} />,
    python: <FaPython className={className} />,
    java: <FaJava className={className} />,
    figma: <FaFigma className={className} />,
    html5: <FaHtml5 className={className} />,
    nodejs: <FaNodeJs className={className} />,
    react: <FaReact className={className} />,
    mail: <IoMdMail className={className} />,
    tailwind: <RiTailwindCssFill className={className} />,
    ruby: <DiRuby className={className} />,
    blender: <SiBlender className={className} />,
    typescript: <SiTypescript className={className} />,
    clock: <ClockIcon className={className} />,
    briefcase: <Briefcase className={className} />,
    map: <MapPin className={className} />,
    email: <Mail className={className} />,
  };

  return icons[name.toLowerCase()] || <span className={className}>{name}</span>;
};

export default TechIcon;
